import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { LegalStatusEnum } from '../../../../../models/enums/legal-status.enum';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  BaryButtonComponent,
  BaryCardComponent,
  BaryInputSelectComponent,
  BaryInputTextComponent,
  BarySiretComponent
} from '../../../components';
import { NgIf } from '@angular/common';
import { CardsModule } from 'ng-uikit-pro-standard';
import { User } from '../../../../../models/user.model';

@Component({
  selector: 'jhi-company-card',
  standalone: true,
  imports: [
    BaryCardComponent,
    BaryInputSelectComponent,
    TranslateModule,
    BaryInputTextComponent,
    BarySiretComponent,
    BaryButtonComponent,
    NgIf,
    CardsModule
  ],
  templateUrl: './company-card.component.html',
  styleUrls: ['./company-card.component.scss'],
})
export class CompanyCardComponent {
  readonly #translateService = inject(TranslateService);

  @Input() baryForm!: FormGroup;
  @Input() editable = true;
  @Input() switchButton = false;
  @Input() description?: string;
  @Input() user?: User;
  @Output() saveEvent = new EventEmitter<boolean>();

  public legalStatusOptions = [
    {
      label: this.#translateService.instant('LABEL.COMPANY_LEGAL_STATUS.EMPTY'),
      value: undefined,
    },
    {
      label: this.#translateService.instant('LABEL.COMPANY_LEGAL_STATUS.SOLE_PROPRIETORSHIP'),
      value: LegalStatusEnum.ENTREPRISE_INDIVIDUELLE,
    },
    {
      label: this.#translateService.instant('LABEL.COMPANY_LEGAL_STATUS.MICRO_ENTERPRISE'),
      value: LegalStatusEnum.MICRO_ENTREPRISE,
    },
    {
      label: this.#translateService.instant('LABEL.COMPANY_LEGAL_STATUS.SERVICE_PUBLIC_AND_COMMUNITY'),
      value: LegalStatusEnum.SERVICE_PUBLIC_AND_COMMUNITY,
    },
    {
      label: this.#translateService.instant('LABEL.COMPANY_LEGAL_STATUS.SA'),
      value: LegalStatusEnum.SA,
    },
    {
      label: this.#translateService.instant('LABEL.COMPANY_LEGAL_STATUS.SASU'),
      value: LegalStatusEnum.SASU,
    },
    {
      label: this.#translateService.instant('LABEL.COMPANY_LEGAL_STATUS.EURL'),
      value: LegalStatusEnum.EURL,
    },
    {
      label: this.#translateService.instant('LABEL.COMPANY_LEGAL_STATUS.EARL'),
      value: LegalStatusEnum.EARL,
    },
    {
      label: this.#translateService.instant('LABEL.COMPANY_LEGAL_STATUS.SAS'),
      value: LegalStatusEnum.SAS,
    },
    {
      label: this.#translateService.instant('LABEL.COMPANY_LEGAL_STATUS.SARL'),
      value: LegalStatusEnum.SARL,
    },
    {
      label: this.#translateService.instant('LABEL.COMPANY_LEGAL_STATUS.SCI'),
      value: LegalStatusEnum.SCI,
    },
    {
      label: this.#translateService.instant('LABEL.COMPANY_LEGAL_STATUS.SICA'),
      value: LegalStatusEnum.SICA,
    },
    {
      label: this.#translateService.instant('LABEL.COMPANY_LEGAL_STATUS.SCEA'),
      value: LegalStatusEnum.SCEA,
    },
    {
      label: this.#translateService.instant('LABEL.COMPANY_LEGAL_STATUS.SNC'),
      value: LegalStatusEnum.SNC,
    },
    {
      label: this.#translateService.instant('LABEL.COMPANY_LEGAL_STATUS.SCS'),
      value: LegalStatusEnum.SCS,
    },
    {
      label: this.#translateService.instant('LABEL.COMPANY_LEGAL_STATUS.SCA'),
      value: LegalStatusEnum.SCA,
    },
  ];

  get companyForm(): FormGroup {
    return this.baryForm.get('companyForm') as FormGroup;
  }

  getCompanyControl(name: string): FormControl {
    return this.companyForm.get(name) as FormControl;
  }
}
